import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static outlets = ['game-screen--sound-effect-player'];
  static values = { id: Number, url: String };
  static effects = ['play_once'];

  gameScreenSoundEffectPlayerOutletConnected() { this.dispatch('ready'); }

  get player() {
    const screen = this.element.closest('[data-controller~="automation"]');
    return this.gameScreenSoundEffectPlayerOutlets.find(player => player.element.closest('[data-controller~="automation"]') === screen);
  }

  beginEvaluation() {
    // Keep match state on the element so a Stimulus reconnect does not replay it.
    this.matched = this.element.soundAutomationMatches ||= new Set();
    this.currentMatches = new Set();
  }

  play_once(automationId) {
    this.currentMatches.add(automationId);
    if (this.matched.has(automationId)) return;
    if (this.player?.play(this.urlValue)) this.matched.add(automationId);
  }

  finishEvaluation() {
    for (const id of this.matched) {
      if (!this.currentMatches.has(id)) this.matched.delete(id);
    }
  }
}
